module.exports = __webpack_public_path__ + "img/kids.2f74d596.png";